import Button from "@/components/base/Button";

const BeamedEighthNote = ({ className = '' }: { className?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width="26"
    height="26"
    fill="currentColor"
    className={className}
    aria-hidden="true"
  >
    {/* Balken oben - verbindet beide Notenhälse */}
    <path d="M9.4 4.1 L20.6 2.5 L20.6 4.9 L9.4 6.5 Z" />
    {/* linker Hals */}
    <rect x="9.4" y="4.9" width="1.6" height="12.4" />
    {/* rechter Hals */}
    <rect x="19.0" y="3.3" width="1.6" height="12.4" />
    {/* Note links */}
    <ellipse cx="6.0" cy="18.2" rx="4.4" ry="3.3" transform="rotate(-22 6.0 18.2)" />
    {/* Note rechts */}
    <ellipse cx="15.6" cy="16.6" rx="4.4" ry="3.3" transform="rotate(-22 15.6 16.6)" />
  </svg>
);

const CARD_ACTION =
  "border-ink/20 hover:bg-ink hover:text-bg w-full md:w-auto md:min-w-[11rem] h-12";

// Icon-Buttons (Herz, Orange, Note): gleiche Höhe wie die Text-Buttons,
// nur etwas enger im Innenabstand, damit sie nicht unnötig breit werden.
const CARD_ACTION_ICON =
  "border-ink/20 hover:bg-ink w-full md:w-auto h-12 px-4 text-sm";

export default function StatsCTAs({ onViewGallery }: { onViewGallery: () => void }) {
  return (
    <div className="relative px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="mt-4 grid grid-cols-1 [grid-auto-rows:1fr] gap-4">
        <div
          data-reveal
          data-delay="5"
          className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 p-5 md:p-10 rounded-2xl border border-line bg-bgSoft/40"
        >
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-moss/10 border border-moss/30 shrink-0">
            <svg viewBox="0 0 30 20" width="28" height="18" className="text-moss">
              {/* Querbalken - liegen hinter den Latten */}
              <rect x="0" y="5" width="30" height="2" fill="currentColor" rx="1" />
              <rect x="0" y="13" width="30" height="2" fill="currentColor" rx="1" />
              {/* 5 Latten - liegen über den Querbalken */}
              <rect x="2" y="3" width="2" height="17" fill="currentColor" rx="0.5" />
              <rect x="8" y="3" width="2" height="17" fill="currentColor" rx="0.5" />
              <rect x="14" y="3" width="2" height="17" fill="currentColor" rx="0.5" />
              <rect x="20" y="3" width="2" height="17" fill="currentColor" rx="0.5" />
              <rect x="26" y="3" width="2" height="17" fill="currentColor" rx="0.5" />
              {/* Spitzen - liegen über den Latten */}
              <path d="M3,0 L2,3 L4,3 Z" fill="currentColor" />
              <path d="M9,0 L8,3 L10,3 Z" fill="currentColor" />
              <path d="M15,0 L14,3 L16,3 Z" fill="currentColor" />
              <path d="M21,0 L20,3 L22,3 Z" fill="currentColor" />
              <path d="M27,0 L26,3 L28,3 Z" fill="currentColor" />
            </svg>
          </div>
          <div className="flex-1">
            <p className="font-display italic text-lg md:text-xl text-ink mb-1">
              Schauen Sie bei uns über den Zaun …
            </p>
            <p className="text-sm text-inkDim">
              Noch besser können Sie uns bei einem Treffen kennenlernen. In Remagen. In Bonn. Oder virtuell.
            </p>
          </div>
          <Button
            variant="outline"
            onClick={onViewGallery}
            className={CARD_ACTION}
          >
            Bildergalerie <i className="ri-arrow-right-line"></i>
          </Button>
        </div>

        <div
          data-reveal
          data-delay="6"
          className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 p-5 md:p-10 rounded-2xl border border-line bg-bgSoft/40"
        >
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-moss/10 border border-moss/30 shrink-0">
            <i className="ri-book-open-line text-moss text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="font-display italic text-lg md:text-xl text-ink mb-1">
              …oder in unsere Vocatur-Fibel …
            </p>
            <p className="text-sm text-inkDim">
              Es bleibt dabei: WIR SOLLTEN UNS TREFFEN!
            </p>
          </div>
          <Button
            href="https://storage.helloreaddy.io/project_files/fec1b3e3-c832-4504-ae05-19db151b3fe7/67a1d10e-3077-4f5f-bda7-0f14fed2f5da_Fibel_Vocatur_GmbH_19082025.pdf"
            target="_blank"
            rel="noopener noreferrer"
            download
            variant="outline"
            className={CARD_ACTION}
          >
            Download
            <i className="ri-arrow-right-line"></i>
          </Button>
        </div>

        {/* handgepackt eGbR */}
        <div
          data-reveal
          data-delay="7"
          className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 p-5 md:p-10 rounded-2xl border border-line bg-bgSoft/40"
        >
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-moss/10 border border-moss/30 shrink-0">
            <i className="ri-lightbulb-line text-moss text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="font-display italic text-lg md:text-xl text-ink mb-1">
              …oder in Nachbars Garten zu unserer Schwesterfirma handgepackt eGbR …
            </p>
            <p className="text-sm text-inkDim">
              Dort fulfillen wir für Sie alles, was fulfillt werden soll. 
            </p>
          </div>
          <Button
            href="https://www.handgepackt.de/"
            target="_blank"
            rel="noopener noreferrer"
            variant="outline"
            size="sm"
            className={CARD_ACTION_ICON}
          >
            <span className="w-9 h-9 flex items-center justify-center shrink-0" aria-hidden="true">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="#B80E10">
                <path d="M12.001 4.52853C14.35 2.42 17.98 2.49 20.2426 4.75736C22.5053 7.02472 22.583 10.637 20.4786 12.993L11.9999 21.485L3.52138 12.993C1.41705 10.637 1.49571 7.01901 3.75736 4.75736C6.02157 2.49315 9.64519 2.41687 12.001 4.52853Z"/>
              </svg>
            </span>
            <i className="ri-arrow-right-line"></i>
          </Button>
        </div>

        {/* com4people GmbH */}
        <div
          data-reveal
          data-delay="8"
          className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 p-5 md:p-10 rounded-2xl border border-line bg-bgSoft/40"
        >
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-moss/10 border border-moss/30 shrink-0">
            <i className="ri-code-s-slash-line text-moss text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="font-display italic text-lg md:text-xl text-ink mb-1">
              …oder zu unserer Softwareschmiede com4people GmbH.
            </p>
            <p className="text-sm text-inkDim">
              Dort gießen wir das in kluge Lösungen, was wir täglich in den Gesprächen mit Ihnen und Ihren Kunden lernen.
            </p>
          </div>
          <Button
            href="https://www.com4people.com/"
            target="_blank"
            rel="noopener noreferrer"
            variant="outline"
            size="sm"
            className={CARD_ACTION_ICON}
          >
            <span className="relative w-9 h-9 flex items-center justify-center shrink-0" aria-hidden="true">
              <span className="w-6 h-6 rounded-full bg-gradient-to-br from-orange-400 to-orange-600"></span>
              <i className="ri-leaf-line absolute top-0.5 right-0.5 text-[11px] text-green-800 -rotate-12"></i>
            </span>
            <i className="ri-arrow-right-line"></i>
          </Button>
        </div>

        {/* Hörbuch - Deutschlands beste Arbeitgeberinnen */}
        <div
          data-reveal
          data-delay="9"
          className="flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6 p-5 md:p-10 rounded-2xl border border-line bg-bgSoft/40"
        >
          <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-moss/10 border border-moss/30 shrink-0">
            <i className="ri-volume-up-line text-moss text-xl"></i>
          </div>
          <div className="flex-1">
            <p className="font-display italic text-lg md:text-xl text-ink mb-1">
              Und wenn Sie Hörbücher mögen, dann genießen Sie doch einfach das Kapitel
              „Liebeskummer, Grieß und Kinder - Warum Frauen die besseren Führungskräfte sind“
              aus dem Buch „Deutschlands beste Arbeitgeberinnen“.
            </p>
            <p className="text-sm text-inkDim">
              Hier wird ein bisschen von Diana Runkel geschwärmt.
            </p>
          </div>
          <Button
            href="https://autorenclub.de/lp/marian-prill-verlag-1732/deutschlands-beste-arbeitgeberinnen-vocatur-gmbh"
            target="_blank"
            rel="noopener noreferrer"
            variant="outline"
            size="sm"
            className={CARD_ACTION_ICON}
          >
            <span className="w-9 h-9 flex items-center justify-center shrink-0" aria-hidden="true">
              <BeamedEighthNote className="text-[#2F6FDB]" />
            </span>
            <i className="ri-arrow-right-line"></i>
          </Button>
        </div>
        </div>
      </div>
    </div>
  );
}